
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface SubscriptionSuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
  mentorId?: string;
  mentorName?: string;
}

const SubscriptionSuccessDialog = ({ 
  isOpen, 
  onClose, 
  mentorId, 
  mentorName 
}: SubscriptionSuccessDialogProps) => {
  const navigate = useNavigate();

  const handleMessageMentor = () => {
    // Navigate to messages page with mentor conversation if available
    if (mentorId) {
      navigate(`/messages?mentor=${mentorId}`);
    } else {
      navigate('/messages');
    }
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          <DialogTitle className="text-center text-xl">
            Your subscription is now activated!
          </DialogTitle>
        </DialogHeader>
        
        <div className="text-center space-y-4">
          <p className="text-gray-600">
            You can now message your mentor via our chat service.
          </p>
          
          <div className="pt-4">
            <Button
              onClick={handleMessageMentor}
              className="w-full bg-emu-blue hover:bg-emu-blue/90"
            >
              <MessageCircle className="mr-2 h-4 w-4" />
              {mentorName ? `Message ${mentorName}` : 'Go to Messages'}
            </Button>
          </div>
          
          <Button 
            variant="outline" 
            onClick={onClose}
            className="w-full"
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionSuccessDialog;
